// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Our Memories marketing — premium photo-first landing */

.photostudio-marketing {
  --om-ink: #141210;
  --om-ink-soft: #5c574f;
  --om-ink-faint: #8a847a;
  --om-paper: #f7f6f3;
  --om-paper-soft: #eceae4;
  --om-surface: #fffcf8;
  --om-line: rgba(20, 18, 16, 0.1);
  --om-line-strong: rgba(20, 18, 16, 0.16);
  --om-accent: #1f3a34;
  --om-r: 14px;
  --om-dur: 180ms;
  --om-font-display: "Cormorant Garamond", Georgia, "Times New Roman", serif;
  --om-font-body: "Outfit", "Segoe UI", sans-serif;

  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  background: var(--om-paper);
  color: var(--om-ink);
  font-family: var(--om-font-body);
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html.dark .photostudio-marketing {
  color: var(--om-ink);
  background: var(--om-paper);
}

.photostudio-marketing .container-page {
  width: 100%;
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
  padding-left: clamp(1.25rem, 4vw, 2.5rem);
  padding-right: clamp(1.25rem, 4vw, 2.5rem);
  box-sizing: border-box;
}

.photostudio-marketing #home,
.photostudio-marketing #features,
.photostudio-marketing #how,
.photostudio-marketing #users,
.photostudio-marketing #blogs {
  scroll-margin-top: 5rem;
}

/* —— Buttons —— */
.photostudio-marketing .om-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 48px;
  padding: 0 1.25rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-family: var(--om-font-body);
  font-size: 0.9rem;
  font-weight: 550;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background var(--om-dur) ease, color var(--om-dur) ease, border-color var(--om-dur) ease, transform var(--om-dur) ease;
}

.photostudio-marketing .om-btn:focus-visible,
.photostudio-marketing .om-header__link:focus-visible,
.photostudio-marketing .om-blog-card:focus-visible {
  outline: 2px solid var(--om-accent);
  outline-offset: 2px;
}

.photostudio-marketing .om-btn--dark {
  background: var(--om-ink);
  color: #fffcf8;
}

.photostudio-marketing .om-btn--dark:hover {
  background: #2a2622;
}

.photostudio-marketing .om-btn--light {
  background: #fffcf8;
  color: var(--om-ink);
}

.photostudio-marketing .om-btn--light:hover {
  background: #fff;
}

.photostudio-marketing .om-btn--ghost {
  background: transparent;
  border-color: rgba(255, 252, 248, 0.35);
  color: #fffcf8;
}

.photostudio-marketing .om-btn--ghost:hover {
  background: rgba(255, 252, 248, 0.1);
}

.photostudio-marketing .om-section .om-btn--ghost,
.photostudio-marketing .om-cta .om-btn--ghost {
  border-color: var(--om-line-strong);
  color: var(--om-ink);
  background: var(--om-surface);
}

.photostudio-marketing .om-section .om-btn--ghost:hover,
.photostudio-marketing .om-cta .om-btn--ghost:hover {
  background: var(--om-paper-soft);
}

.photostudio-marketing .om-hero .om-btn--ghost {
  border-color: rgba(255, 252, 248, 0.4);
  color: #fffcf8;
  background: rgba(255, 252, 248, 0.08);
}

.photostudio-marketing .om-hero .om-btn--ghost:hover {
  background: rgba(255, 252, 248, 0.16);
}

.photostudio-marketing .om-btn--compact {
  min-height: 42px;
  padding: 0 1rem;
  font-size: 0.84rem;
}

.photostudio-marketing .om-btn--block {
  width: 100%;
}

.photostudio-marketing .om-stores {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.photostudio-marketing .om-stores--center {
  justify-content: center;
}

/* —— Header —— */
.photostudio-marketing .om-header {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(247, 246, 243, 0.9);
  border-bottom: 1px solid var(--om-line);
  backdrop-filter: blur(14px);
}

.photostudio-marketing .om-header__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 4.25rem;
}

.photostudio-marketing .om-header__brand {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  text-decoration: none;
  color: inherit;
}

.photostudio-marketing .om-header__name {
  font-family: var(--om-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.photostudio-marketing .om-header__nav {
  display: none;
  align-items: center;
  gap: 0.25rem;
}

@media (min-width: 960px) {
  .photostudio-marketing .om-header__nav {
    display: flex;
  }
}

.photostudio-marketing .om-header__link {
  padding: 0.55rem 0.85rem;
  border-radius: 999px;
  color: var(--om-ink-soft);
  font-size: 0.9rem;
  font-weight: 500;
  text-decoration: none;
  transition: color var(--om-dur) ease, background var(--om-dur) ease;
}

.photostudio-marketing .om-header__link:hover {
  color: var(--om-ink);
  background: rgba(20, 18, 16, 0.04);
}

.photostudio-marketing .om-header__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.photostudio-marketing .om-header__cta {
  display: none;
}

@media (min-width: 640px) {
  .photostudio-marketing .om-header__cta {
    display: inline-flex;
  }
}

.photostudio-marketing .om-header__menu-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid var(--om-line-strong);
  background: var(--om-surface);
  color: var(--om-ink);
  cursor: pointer;
}

@media (min-width: 960px) {
  .photostudio-marketing .om-header__menu-btn {
    display: none;
  }
}

.photostudio-marketing .om-header__drawer {
  border-top: 1px solid var(--om-line);
  background: var(--om-surface);
  padding: 0.75rem 0 1.25rem;
}

.photostudio-marketing .om-header__drawer-link {
  display: block;
  padding: 0.85rem 0;
  border-bottom: 1px solid var(--om-line);
  color: var(--om-ink);
  font-weight: 550;
  text-decoration: none;
}

.photostudio-marketing .om-header__drawer .om-btn {
  margin-top: 1rem;
}

/* —— Hero —— */
.photostudio-marketing .om-hero {
  position: relative;
  isolation: isolate;
  min-height: min(88vh, 820px);
  display: flex;
  align-items: flex-end;
  color: #fffcf8;
  overflow: hidden;
}

.photostudio-marketing .om-hero__media {
  position: absolute;
  inset: 0;
  z-index: -1;
}

.photostudio-marketing .om-hero__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 28%;
  display: block;
}

.photostudio-marketing .om-hero__veil {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(10, 9, 8, 0.28) 0%, rgba(10, 9, 8, 0.18) 35%, rgba(10, 9, 8, 0.78) 100%),
    linear-gradient(90deg, rgba(10, 9, 8, 0.58) 0%, rgba(10, 9, 8, 0.18) 55%, transparent 100%);
}

.photostudio-marketing .om-hero__content {
  width: 100%;
  padding-top: 6rem;
  padding-bottom: clamp(2rem, 5vh, 3.75rem);
}

.photostudio-marketing .om-brand {
  margin: 0 0 0.65rem;
  font-family: var(--om-font-display);
  font-size: clamp(2rem, 4.8vw, 3.6rem);
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 0.95;
  color: #fffcf8;
}

.photostudio-marketing .om-hero__title {
  margin: 0;
  max-width: 18ch;
  font-family: var(--om-font-display);
  font-size: clamp(1.55rem, 3.4vw, 2.55rem);
  font-weight: 550;
  letter-spacing: -0.025em;
  line-height: 1.15;
}

.photostudio-marketing .om-hero__lead {
  margin: 0.85rem 0 0;
  max-width: 40ch;
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 252, 248, 0.86);
}

.photostudio-marketing .om-hero__cta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.35rem;
}

@media (min-width: 720px) {
  .photostudio-marketing .om-hero__cta {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
}

/* —— Sections —— */
.photostudio-marketing .om-section {
  padding: clamp(4rem, 8vw, 6.5rem) 0;
}

.photostudio-marketing .om-section--soft {
  background: var(--om-paper-soft);
}

.photostudio-marketing .om-section--ink {
  background: #151412;
  color: #fffcf8;
}

.photostudio-marketing .om-section__intro {
  max-width: 42rem;
  margin-bottom: 2.5rem;
}

.photostudio-marketing .om-section__intro--narrow {
  max-width: 34rem;
}

.photostudio-marketing .om-kicker {
  margin: 0 0 0.75rem;
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--om-ink-faint);
}

.photostudio-marketing .om-kicker--light {
  color: rgba(255, 252, 248, 0.55);
}

.photostudio-marketing .om-heading {
  margin: 0;
  font-family: var(--om-font-display);
  font-size: clamp(1.85rem, 3.5vw, 3rem);
  font-weight: 560;
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--om-ink);
}

.photostudio-marketing .om-heading--light {
  color: #fffcf8;
}

.photostudio-marketing .om-subcopy {
  margin: 1rem 0 0;
  max-width: 42ch;
  font-size: 1.02rem;
  line-height: 1.65;
  color: var(--om-ink-soft);
}

.photostudio-marketing .om-section--ink .om-subcopy {
  color: rgba(255, 252, 248, 0.72);
}

/* Feature showcase */
.photostudio-marketing .om-feature-showcase {
  display: grid;
  grid-template-columns: 1.15fr 0.9fr 0.9fr;
  gap: 0.85rem;
  margin-bottom: 2.25rem;
}

@media (max-width: 800px) {
  .photostudio-marketing .om-feature-showcase {
    grid-template-columns: 1fr 1fr;
  }
  .photostudio-marketing .om-feature-showcase__frame:first-child {
    grid-column: 1 / -1;
  }
}

.photostudio-marketing .om-feature-showcase__frame {
  margin: 0;
  overflow: hidden;
  border-radius: var(--om-r);
  background: #1a1816;
  aspect-ratio: 3 / 4;
}

.photostudio-marketing .om-feature-showcase__frame:first-child {
  aspect-ratio: 4 / 5;
}

.photostudio-marketing .om-feature-showcase__frame img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  transition: transform 220ms ease;
}

@media (hover: hover) {
  .photostudio-marketing .om-feature-showcase__frame:hover img {
    transform: scale(1.03);
  }
}

.photostudio-marketing .om-feature-list {
  display: grid;
  gap: 1.25rem 1.75rem;
}

@media (min-width: 720px) {
  .photostudio-marketing .om-feature-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .photostudio-marketing .om-feature-list {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.photostudio-marketing .om-feature-item {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding-top: 1.15rem;
  border-top: 1px solid var(--om-line);
}

.photostudio-marketing .om-feature-item__icon {
  flex-shrink: 0;
  margin-top: 0.15rem;
  color: var(--om-accent);
}

.photostudio-marketing .om-feature-item__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.photostudio-marketing .om-feature-item__text {
  margin: 0.35rem 0 0;
  font-size: 0.92rem;
  line-height: 1.55;
  color: var(--om-ink-soft);
}

/* Journey */
.photostudio-marketing .om-journey {
  display: grid;
  gap: 2.5rem;
}

@media (min-width: 960px) {
  .photostudio-marketing .om-journey {
    grid-template-columns: 1.25fr 0.9fr;
    align-items: center;
    gap: 3rem;
  }
}

.photostudio-marketing .om-steps {
  list-style: none;
  margin: 2rem 0 0;
  padding: 0;
  display: grid;
  gap: 1rem;
}

.photostudio-marketing .om-steps__item {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 1rem;
  align-items: start;
}

.photostudio-marketing .om-steps__num {
  font-family: var(--om-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  line-height: 1;
  color: rgba(255, 252, 248, 0.45);
}

.photostudio-marketing .om-steps__item p {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.55;
  color: rgba(255, 252, 248, 0.88);
}

.photostudio-marketing .om-journey__panel {
  padding: 1.75rem;
  border: 1px solid rgba(255, 252, 248, 0.14);
  border-radius: 18px;
  background: rgba(255, 252, 248, 0.04);
}

.photostudio-marketing .om-journey__panel-title {
  margin: 0;
  font-family: var(--om-font-display);
  font-size: 1.85rem;
  font-weight: 560;
  letter-spacing: -0.02em;
}

.photostudio-marketing .om-journey__panel-text {
  margin: 0.75rem 0 1.35rem;
  font-size: 0.95rem;
  line-height: 1.6;
  color: rgba(255, 252, 248, 0.72);
}

/* Audience */
.photostudio-marketing .om-audience {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.photostudio-marketing .om-audience__item {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 44px;
  padding: 0.65rem 1rem;
  border-radius: 999px;
  border: 1px solid var(--om-line-strong);
  background: var(--om-surface);
  font-size: 0.95rem;
  font-weight: 550;
  color: var(--om-ink);
}

.photostudio-marketing .om-audience__item svg {
  color: var(--om-accent);
}

/* Blog */
.photostudio-marketing .om-blog-grid {
  display: grid;
  gap: 1rem;
}

@media (min-width: 800px) {
  .photostudio-marketing .om-blog-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .photostudio-marketing .om-blog-card--lead {
    grid-column: 1 / -1;
  }
}

.photostudio-marketing .om-blog-card {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding: 1.5rem 1.35rem;
  border-radius: 16px;
  border: 1px solid var(--om-line);
  background: var(--om-surface);
  text-decoration: none;
  color: inherit;
  transition: border-color var(--om-dur) ease, transform var(--om-dur) ease;
}

.photostudio-marketing .om-blog-card:hover {
  border-color: var(--om-line-strong);
  transform: translateY(-2px);
}

.photostudio-marketing .om-blog-card--lead {
  padding: 2rem 1.75rem;
}

.photostudio-marketing .om-blog-card__index {
  font-size: 0.72rem;
  font-weight: 650;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--om-ink-faint);
}

.photostudio-marketing .om-blog-card__title {
  margin: 0;
  font-family: var(--om-font-display);
  font-size: 1.55rem;
  font-weight: 560;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.photostudio-marketing .om-blog-card--lead .om-blog-card__title {
  font-size: clamp(1.7rem, 3vw, 2.2rem);
  max-width: 22ch;
}

.photostudio-marketing .om-blog-card__desc {
  margin: 0;
  max-width: 48ch;
  font-size: 0.95rem;
  line-height: 1.6;
  color: var(--om-ink-soft);
}

.photostudio-marketing .om-blog-card__link {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.35rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--om-accent);
}

/* CTA */
.photostudio-marketing .om-cta {
  padding-top: 0;
}

.photostudio-marketing .om-cta__inner {
  padding: clamp(2.5rem, 6vw, 4rem);
  border-radius: 22px;
  background:
    linear-gradient(135deg, rgba(31, 58, 52, 0.08), transparent 45%),
    var(--om-surface);
  border: 1px solid var(--om-line);
  text-align: center;
}

.photostudio-marketing .om-cta__inner .om-heading {
  max-width: 18ch;
  margin-left: auto;
  margin-right: auto;
}

.photostudio-marketing .om-cta__inner .om-subcopy {
  margin-left: auto;
  margin-right: auto;
}

.photostudio-marketing .om-cta__actions {
  margin-top: 1.75rem;
}

/* Footer */
.photostudio-marketing .om-footer {
  padding: 3rem 0 2rem;
  background: #151412;
  color: #fffcf8;
}

.photostudio-marketing .om-footer__inner {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  justify-content: space-between;
}

@media (min-width: 800px) {
  .photostudio-marketing .om-footer__inner {
    flex-direction: row;
    align-items: flex-start;
  }
}

.photostudio-marketing .om-footer__logo-row {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  font-family: var(--om-font-display);
  font-size: 1.35rem;
  font-weight: 600;
}

.photostudio-marketing .om-footer__brand p {
  margin: 0.75rem 0 0;
  max-width: 34ch;
  font-size: 0.92rem;
  line-height: 1.6;
  color: rgba(255, 252, 248, 0.7);
}

.photostudio-marketing .om-footer__nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem 1.25rem;
}

.photostudio-marketing .om-footer__nav a {
  color: rgba(255, 252, 248, 0.78);
  font-size: 0.9rem;
  text-decoration: none;
}

.photostudio-marketing .om-footer__nav a:hover {
  color: #fff;
}

.photostudio-marketing .om-footer__copy {
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(255, 252, 248, 0.1);
  font-size: 0.8rem;
  color: rgba(255, 252, 248, 0.5);
}

/* Policy / blog article helpers */
.photostudio-marketing .prose-page h2 {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-family: var(--om-font-display);
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--om-ink);
}

.photostudio-marketing .prose-page p {
  line-height: 1.75;
  color: var(--om-ink-soft);
}

.photostudio-marketing .prose-page a {
  color: var(--om-accent);
  font-weight: 600;
}

@media (prefers-reduced-motion: reduce) {
  .photostudio-marketing *,
  .photostudio-marketing *::before,
  .photostudio-marketing *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./photostudio-react-tailwind/src/photostudio-theme.css"],"names":[],"mappings":"AAAA,yDAAyD;;AAEzD;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,0EAA0E;EAC1E,gDAAgD;;EAEhD,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,6BAA6B;EAC7B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,kIAAkI;AACpI;;AAEA;;;EAGE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,mCAAmC;EACnC,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,oCAAoC;EACpC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mEAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;+FAE6F;AAC/F;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;EACnC,yCAAyC;EACzC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE;IACE,mCAAmC;IACnC,mBAAmB;IACnB,SAAS;EACX;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,yEAAyE;AAC3E;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,QAAQ;AACR;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB;;qBAEmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,8CAA8C;EAC9C,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;EACxC;AACF","sourcesContent":["/* Our Memories marketing — premium photo-first landing */\n\n.photostudio-marketing {\n  --om-ink: #141210;\n  --om-ink-soft: #5c574f;\n  --om-ink-faint: #8a847a;\n  --om-paper: #f7f6f3;\n  --om-paper-soft: #eceae4;\n  --om-surface: #fffcf8;\n  --om-line: rgba(20, 18, 16, 0.1);\n  --om-line-strong: rgba(20, 18, 16, 0.16);\n  --om-accent: #1f3a34;\n  --om-r: 14px;\n  --om-dur: 180ms;\n  --om-font-display: \"Cormorant Garamond\", Georgia, \"Times New Roman\", serif;\n  --om-font-body: \"Outfit\", \"Segoe UI\", sans-serif;\n\n  width: 100%;\n  max-width: 100vw;\n  min-height: 100vh;\n  min-height: 100dvh;\n  background: var(--om-paper);\n  color: var(--om-ink);\n  font-family: var(--om-font-body);\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml.dark .photostudio-marketing {\n  color: var(--om-ink);\n  background: var(--om-paper);\n}\n\n.photostudio-marketing .container-page {\n  width: 100%;\n  max-width: 1180px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: clamp(1.25rem, 4vw, 2.5rem);\n  padding-right: clamp(1.25rem, 4vw, 2.5rem);\n  box-sizing: border-box;\n}\n\n.photostudio-marketing #home,\n.photostudio-marketing #features,\n.photostudio-marketing #how,\n.photostudio-marketing #users,\n.photostudio-marketing #blogs {\n  scroll-margin-top: 5rem;\n}\n\n/* —— Buttons —— */\n.photostudio-marketing .om-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  min-height: 48px;\n  padding: 0 1.25rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-family: var(--om-font-body);\n  font-size: 0.9rem;\n  font-weight: 550;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background var(--om-dur) ease, color var(--om-dur) ease, border-color var(--om-dur) ease, transform var(--om-dur) ease;\n}\n\n.photostudio-marketing .om-btn:focus-visible,\n.photostudio-marketing .om-header__link:focus-visible,\n.photostudio-marketing .om-blog-card:focus-visible {\n  outline: 2px solid var(--om-accent);\n  outline-offset: 2px;\n}\n\n.photostudio-marketing .om-btn--dark {\n  background: var(--om-ink);\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-btn--dark:hover {\n  background: #2a2622;\n}\n\n.photostudio-marketing .om-btn--light {\n  background: #fffcf8;\n  color: var(--om-ink);\n}\n\n.photostudio-marketing .om-btn--light:hover {\n  background: #fff;\n}\n\n.photostudio-marketing .om-btn--ghost {\n  background: transparent;\n  border-color: rgba(255, 252, 248, 0.35);\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-btn--ghost:hover {\n  background: rgba(255, 252, 248, 0.1);\n}\n\n.photostudio-marketing .om-section .om-btn--ghost,\n.photostudio-marketing .om-cta .om-btn--ghost {\n  border-color: var(--om-line-strong);\n  color: var(--om-ink);\n  background: var(--om-surface);\n}\n\n.photostudio-marketing .om-section .om-btn--ghost:hover,\n.photostudio-marketing .om-cta .om-btn--ghost:hover {\n  background: var(--om-paper-soft);\n}\n\n.photostudio-marketing .om-hero .om-btn--ghost {\n  border-color: rgba(255, 252, 248, 0.4);\n  color: #fffcf8;\n  background: rgba(255, 252, 248, 0.08);\n}\n\n.photostudio-marketing .om-hero .om-btn--ghost:hover {\n  background: rgba(255, 252, 248, 0.16);\n}\n\n.photostudio-marketing .om-btn--compact {\n  min-height: 42px;\n  padding: 0 1rem;\n  font-size: 0.84rem;\n}\n\n.photostudio-marketing .om-btn--block {\n  width: 100%;\n}\n\n.photostudio-marketing .om-stores {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.photostudio-marketing .om-stores--center {\n  justify-content: center;\n}\n\n/* —— Header —— */\n.photostudio-marketing .om-header {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: rgba(247, 246, 243, 0.9);\n  border-bottom: 1px solid var(--om-line);\n  backdrop-filter: blur(14px);\n}\n\n.photostudio-marketing .om-header__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  min-height: 4.25rem;\n}\n\n.photostudio-marketing .om-header__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.7rem;\n  text-decoration: none;\n  color: inherit;\n}\n\n.photostudio-marketing .om-header__name {\n  font-family: var(--om-font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.photostudio-marketing .om-header__nav {\n  display: none;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n@media (min-width: 960px) {\n  .photostudio-marketing .om-header__nav {\n    display: flex;\n  }\n}\n\n.photostudio-marketing .om-header__link {\n  padding: 0.55rem 0.85rem;\n  border-radius: 999px;\n  color: var(--om-ink-soft);\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color var(--om-dur) ease, background var(--om-dur) ease;\n}\n\n.photostudio-marketing .om-header__link:hover {\n  color: var(--om-ink);\n  background: rgba(20, 18, 16, 0.04);\n}\n\n.photostudio-marketing .om-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.photostudio-marketing .om-header__cta {\n  display: none;\n}\n\n@media (min-width: 640px) {\n  .photostudio-marketing .om-header__cta {\n    display: inline-flex;\n  }\n}\n\n.photostudio-marketing .om-header__menu-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 12px;\n  border: 1px solid var(--om-line-strong);\n  background: var(--om-surface);\n  color: var(--om-ink);\n  cursor: pointer;\n}\n\n@media (min-width: 960px) {\n  .photostudio-marketing .om-header__menu-btn {\n    display: none;\n  }\n}\n\n.photostudio-marketing .om-header__drawer {\n  border-top: 1px solid var(--om-line);\n  background: var(--om-surface);\n  padding: 0.75rem 0 1.25rem;\n}\n\n.photostudio-marketing .om-header__drawer-link {\n  display: block;\n  padding: 0.85rem 0;\n  border-bottom: 1px solid var(--om-line);\n  color: var(--om-ink);\n  font-weight: 550;\n  text-decoration: none;\n}\n\n.photostudio-marketing .om-header__drawer .om-btn {\n  margin-top: 1rem;\n}\n\n/* —— Hero —— */\n.photostudio-marketing .om-hero {\n  position: relative;\n  isolation: isolate;\n  min-height: min(88vh, 820px);\n  display: flex;\n  align-items: flex-end;\n  color: #fffcf8;\n  overflow: hidden;\n}\n\n.photostudio-marketing .om-hero__media {\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n}\n\n.photostudio-marketing .om-hero__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 28%;\n  display: block;\n}\n\n.photostudio-marketing .om-hero__veil {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(180deg, rgba(10, 9, 8, 0.28) 0%, rgba(10, 9, 8, 0.18) 35%, rgba(10, 9, 8, 0.78) 100%),\n    linear-gradient(90deg, rgba(10, 9, 8, 0.58) 0%, rgba(10, 9, 8, 0.18) 55%, transparent 100%);\n}\n\n.photostudio-marketing .om-hero__content {\n  width: 100%;\n  padding-top: 6rem;\n  padding-bottom: clamp(2rem, 5vh, 3.75rem);\n}\n\n.photostudio-marketing .om-brand {\n  margin: 0 0 0.65rem;\n  font-family: var(--om-font-display);\n  font-size: clamp(2rem, 4.8vw, 3.6rem);\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 0.95;\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-hero__title {\n  margin: 0;\n  max-width: 18ch;\n  font-family: var(--om-font-display);\n  font-size: clamp(1.55rem, 3.4vw, 2.55rem);\n  font-weight: 550;\n  letter-spacing: -0.025em;\n  line-height: 1.15;\n}\n\n.photostudio-marketing .om-hero__lead {\n  margin: 0.85rem 0 0;\n  max-width: 40ch;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(255, 252, 248, 0.86);\n}\n\n.photostudio-marketing .om-hero__cta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-top: 1.35rem;\n}\n\n@media (min-width: 720px) {\n  .photostudio-marketing .om-hero__cta {\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n  }\n}\n\n/* —— Sections —— */\n.photostudio-marketing .om-section {\n  padding: clamp(4rem, 8vw, 6.5rem) 0;\n}\n\n.photostudio-marketing .om-section--soft {\n  background: var(--om-paper-soft);\n}\n\n.photostudio-marketing .om-section--ink {\n  background: #151412;\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-section__intro {\n  max-width: 42rem;\n  margin-bottom: 2.5rem;\n}\n\n.photostudio-marketing .om-section__intro--narrow {\n  max-width: 34rem;\n}\n\n.photostudio-marketing .om-kicker {\n  margin: 0 0 0.75rem;\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--om-ink-faint);\n}\n\n.photostudio-marketing .om-kicker--light {\n  color: rgba(255, 252, 248, 0.55);\n}\n\n.photostudio-marketing .om-heading {\n  margin: 0;\n  font-family: var(--om-font-display);\n  font-size: clamp(1.85rem, 3.5vw, 3rem);\n  font-weight: 560;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--om-ink);\n}\n\n.photostudio-marketing .om-heading--light {\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-subcopy {\n  margin: 1rem 0 0;\n  max-width: 42ch;\n  font-size: 1.02rem;\n  line-height: 1.65;\n  color: var(--om-ink-soft);\n}\n\n.photostudio-marketing .om-section--ink .om-subcopy {\n  color: rgba(255, 252, 248, 0.72);\n}\n\n/* Feature showcase */\n.photostudio-marketing .om-feature-showcase {\n  display: grid;\n  grid-template-columns: 1.15fr 0.9fr 0.9fr;\n  gap: 0.85rem;\n  margin-bottom: 2.25rem;\n}\n\n@media (max-width: 800px) {\n  .photostudio-marketing .om-feature-showcase {\n    grid-template-columns: 1fr 1fr;\n  }\n  .photostudio-marketing .om-feature-showcase__frame:first-child {\n    grid-column: 1 / -1;\n  }\n}\n\n.photostudio-marketing .om-feature-showcase__frame {\n  margin: 0;\n  overflow: hidden;\n  border-radius: var(--om-r);\n  background: #1a1816;\n  aspect-ratio: 3 / 4;\n}\n\n.photostudio-marketing .om-feature-showcase__frame:first-child {\n  aspect-ratio: 4 / 5;\n}\n\n.photostudio-marketing .om-feature-showcase__frame img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n  transition: transform 220ms ease;\n}\n\n@media (hover: hover) {\n  .photostudio-marketing .om-feature-showcase__frame:hover img {\n    transform: scale(1.03);\n  }\n}\n\n.photostudio-marketing .om-feature-list {\n  display: grid;\n  gap: 1.25rem 1.75rem;\n}\n\n@media (min-width: 720px) {\n  .photostudio-marketing .om-feature-list {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1024px) {\n  .photostudio-marketing .om-feature-list {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.photostudio-marketing .om-feature-item {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  padding-top: 1.15rem;\n  border-top: 1px solid var(--om-line);\n}\n\n.photostudio-marketing .om-feature-item__icon {\n  flex-shrink: 0;\n  margin-top: 0.15rem;\n  color: var(--om-accent);\n}\n\n.photostudio-marketing .om-feature-item__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n\n.photostudio-marketing .om-feature-item__text {\n  margin: 0.35rem 0 0;\n  font-size: 0.92rem;\n  line-height: 1.55;\n  color: var(--om-ink-soft);\n}\n\n/* Journey */\n.photostudio-marketing .om-journey {\n  display: grid;\n  gap: 2.5rem;\n}\n\n@media (min-width: 960px) {\n  .photostudio-marketing .om-journey {\n    grid-template-columns: 1.25fr 0.9fr;\n    align-items: center;\n    gap: 3rem;\n  }\n}\n\n.photostudio-marketing .om-steps {\n  list-style: none;\n  margin: 2rem 0 0;\n  padding: 0;\n  display: grid;\n  gap: 1rem;\n}\n\n.photostudio-marketing .om-steps__item {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 1rem;\n  align-items: start;\n}\n\n.photostudio-marketing .om-steps__num {\n  font-family: var(--om-font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  line-height: 1;\n  color: rgba(255, 252, 248, 0.45);\n}\n\n.photostudio-marketing .om-steps__item p {\n  margin: 0;\n  font-size: 0.98rem;\n  line-height: 1.55;\n  color: rgba(255, 252, 248, 0.88);\n}\n\n.photostudio-marketing .om-journey__panel {\n  padding: 1.75rem;\n  border: 1px solid rgba(255, 252, 248, 0.14);\n  border-radius: 18px;\n  background: rgba(255, 252, 248, 0.04);\n}\n\n.photostudio-marketing .om-journey__panel-title {\n  margin: 0;\n  font-family: var(--om-font-display);\n  font-size: 1.85rem;\n  font-weight: 560;\n  letter-spacing: -0.02em;\n}\n\n.photostudio-marketing .om-journey__panel-text {\n  margin: 0.75rem 0 1.35rem;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: rgba(255, 252, 248, 0.72);\n}\n\n/* Audience */\n.photostudio-marketing .om-audience {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.photostudio-marketing .om-audience__item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 44px;\n  padding: 0.65rem 1rem;\n  border-radius: 999px;\n  border: 1px solid var(--om-line-strong);\n  background: var(--om-surface);\n  font-size: 0.95rem;\n  font-weight: 550;\n  color: var(--om-ink);\n}\n\n.photostudio-marketing .om-audience__item svg {\n  color: var(--om-accent);\n}\n\n/* Blog */\n.photostudio-marketing .om-blog-grid {\n  display: grid;\n  gap: 1rem;\n}\n\n@media (min-width: 800px) {\n  .photostudio-marketing .om-blog-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .photostudio-marketing .om-blog-card--lead {\n    grid-column: 1 / -1;\n  }\n}\n\n.photostudio-marketing .om-blog-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding: 1.5rem 1.35rem;\n  border-radius: 16px;\n  border: 1px solid var(--om-line);\n  background: var(--om-surface);\n  text-decoration: none;\n  color: inherit;\n  transition: border-color var(--om-dur) ease, transform var(--om-dur) ease;\n}\n\n.photostudio-marketing .om-blog-card:hover {\n  border-color: var(--om-line-strong);\n  transform: translateY(-2px);\n}\n\n.photostudio-marketing .om-blog-card--lead {\n  padding: 2rem 1.75rem;\n}\n\n.photostudio-marketing .om-blog-card__index {\n  font-size: 0.72rem;\n  font-weight: 650;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--om-ink-faint);\n}\n\n.photostudio-marketing .om-blog-card__title {\n  margin: 0;\n  font-family: var(--om-font-display);\n  font-size: 1.55rem;\n  font-weight: 560;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.photostudio-marketing .om-blog-card--lead .om-blog-card__title {\n  font-size: clamp(1.7rem, 3vw, 2.2rem);\n  max-width: 22ch;\n}\n\n.photostudio-marketing .om-blog-card__desc {\n  margin: 0;\n  max-width: 48ch;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  color: var(--om-ink-soft);\n}\n\n.photostudio-marketing .om-blog-card__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--om-accent);\n}\n\n/* CTA */\n.photostudio-marketing .om-cta {\n  padding-top: 0;\n}\n\n.photostudio-marketing .om-cta__inner {\n  padding: clamp(2.5rem, 6vw, 4rem);\n  border-radius: 22px;\n  background:\n    linear-gradient(135deg, rgba(31, 58, 52, 0.08), transparent 45%),\n    var(--om-surface);\n  border: 1px solid var(--om-line);\n  text-align: center;\n}\n\n.photostudio-marketing .om-cta__inner .om-heading {\n  max-width: 18ch;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.photostudio-marketing .om-cta__inner .om-subcopy {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.photostudio-marketing .om-cta__actions {\n  margin-top: 1.75rem;\n}\n\n/* Footer */\n.photostudio-marketing .om-footer {\n  padding: 3rem 0 2rem;\n  background: #151412;\n  color: #fffcf8;\n}\n\n.photostudio-marketing .om-footer__inner {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n  justify-content: space-between;\n}\n\n@media (min-width: 800px) {\n  .photostudio-marketing .om-footer__inner {\n    flex-direction: row;\n    align-items: flex-start;\n  }\n}\n\n.photostudio-marketing .om-footer__logo-row {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-family: var(--om-font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n}\n\n.photostudio-marketing .om-footer__brand p {\n  margin: 0.75rem 0 0;\n  max-width: 34ch;\n  font-size: 0.92rem;\n  line-height: 1.6;\n  color: rgba(255, 252, 248, 0.7);\n}\n\n.photostudio-marketing .om-footer__nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.85rem 1.25rem;\n}\n\n.photostudio-marketing .om-footer__nav a {\n  color: rgba(255, 252, 248, 0.78);\n  font-size: 0.9rem;\n  text-decoration: none;\n}\n\n.photostudio-marketing .om-footer__nav a:hover {\n  color: #fff;\n}\n\n.photostudio-marketing .om-footer__copy {\n  margin-top: 2rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid rgba(255, 252, 248, 0.1);\n  font-size: 0.8rem;\n  color: rgba(255, 252, 248, 0.5);\n}\n\n/* Policy / blog article helpers */\n.photostudio-marketing .prose-page h2 {\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n  font-family: var(--om-font-display);\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: var(--om-ink);\n}\n\n.photostudio-marketing .prose-page p {\n  line-height: 1.75;\n  color: var(--om-ink-soft);\n}\n\n.photostudio-marketing .prose-page a {\n  color: var(--om-accent);\n  font-weight: 600;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .photostudio-marketing *,\n  .photostudio-marketing *::before,\n  .photostudio-marketing *::after {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
